import { Switcher, SwitcherItem, SwitcherProps } from "@xapp/components";
import { Organization } from "generated/graphql";
import React, { FC, useCallback, useMemo } from "react";
import { useHistory } from "react-router";

export type OrgSwitcherOrg = Pick<Organization, "name" | "logoUrl" | "organizationId">;

export interface OrgSwitcherOrgItem extends SwitcherItem {
    organizationId: string;
    readonly organization: OrgSwitcherOrg;
}

export interface OrgSwitcherProps extends Pick<SwitcherProps, "search" | "onSearchChange" | "showItems" | "onShowItemsChange" | "isLoading" | "isLoadingItems"> {

    readonly orgs?: readonly OrgSwitcherOrg[];
    readonly orgsTotal?: number;
    /**
     * Selected and current organization
     */
    readonly organization?: OrgSwitcherOrg;
    /**
     * finished saves the status of the request and also the
     * number of records found, so we can handle the loader
     * and the message of no records found without need of
     * create anoter variable for this.
     */
    readonly finished?: number | boolean;
    onSelectOrganization(organization: OrgSwitcherOrg): void;
}

function map(org: OrgSwitcherOrg): OrgSwitcherOrgItem {
    return {
        organizationId: org.organizationId,
        logoUrl: org?.logoUrl,
        name: org?.name,
        organization: org,
    };
}

export const OrgSwitcher: FC<OrgSwitcherProps> = (props) => {
    const { orgsTotal, onSelectOrganization, organization } = props;
    const { push } = useHistory();

    const items = useMemo<readonly OrgSwitcherOrgItem[]>(() => props.orgs?.map<OrgSwitcherOrgItem>(map), [props.orgs]);

    const handleSelect = useCallback(
        (item: OrgSwitcherOrgItem) => {
            onSelectOrganization(item.organization);
        },
        [onSelectOrganization]
    );

    const handleNameClick = (value: OrgSwitcherOrgItem) => {
        if (value) {
            push(`/${value.organizationId}`);
        }
    };

    return (
        <Switcher
            items={items}
            itemsTotal={orgsTotal}
            showItems={props.showItems}
            placeholder="Select Organization"
            searchPlaceholder="Choose an organization"
            emptyMessage="No organizations found matching"
            label="Search organizations"
            search={props.search}
            onValueClick={handleNameClick}
            onChange={handleSelect}
            onSearchChange={props.onSearchChange}
            value={organization}
            isLoading={props.isLoading}
            isLoadingItems={props.isLoadingItems}
            onShowItemsChange={props.onShowItemsChange}
            finished={props.finished}
        />
    );
};
